import {
  FontAwesomeIcon,
  Stack,
  Title,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@skailer-com/uikit";
import { ReactNode } from "react";

interface ReportingWidgetProps {
  title: string;
  caption?: string;
  actions?: ReactNode;
  content?: ReactNode;
  tooltip?: ReactNode;
}

export function ReportingWidget({
  title,
  content,
  actions,
  caption,
  tooltip,
}: ReportingWidgetProps) {
  return (
    <Stack className={"p-4.5 rounded-xs shadow-sm bg-light"} gap={"md"}>
      <Stack direction="horizontal" gap="md" items={"baseline"} justify={"between"}>
        <Stack direction={"horizontal"} items={"baseline"}>
          <Title header={title} caption={caption} size="xs" />
          {tooltip && (
            <Tooltip>
              <TooltipTrigger>
                <FontAwesomeIcon icon={"fa-light fa-info-circle"} />
              </TooltipTrigger>
              <TooltipContent className={"max-w-[360px]"}>{tooltip}</TooltipContent>
            </Tooltip>
          )}
        </Stack>
        {actions && actions}
      </Stack>
      {content && content}
    </Stack>
  );
}
